import React from "react";
export default function LatLngToAddress({ lat, lng }) {
  return (
    <ul>
      <li>
        <p>
          <a href="mailto:support@qiktruck.co.za">support@qiktruck.co.za</a>
        </p>
      </li>
      <li>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="tel:+27663784460">
            Call center
          </a>
        </p>
      </li>
      <li>
        <p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://wa.me/+27663784460"
          >
            WhatsApp
          </a>
        </p>
      </li>

      <li>
        <p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://wa.me/+27663784460"
          >
            Vehicle Inspections
          </a>
        </p>
      </li>
      <li>Support Team: +27 66 378 4460 support@qiktruck.co.za </li>
    </ul>
  );
}
